export const SET_ASSET_TRANSACTIONS = 'asset_transactions/SET_ASSET_TRANSACTIONS' as const
export const APPEND_ASSET_TRANSACTIONS = 'asset_transactions/APPEND_ASSET_TRANSACTIONS' as const
export const SET_ACTIVE_FILTERS = 'asset_transactions/SET_ACTIVE_FILTERS' as const
export const SET_ACTIVE_SORTING = 'asset_transactions/SET_ACTIVE_SORTING' as const
export const CLEAR_ACTIVE_FILTERS = 'asset_transactions/CLEAR_ACTIVE_FILTERS' as const
export const UPDATE_ASSET_TRANSACTION_RECORD = 'asset_transactions/UPDATE_ASSET_TRANSACTION_RECORD' as const
export const REMOVE_ASSET_TRANSACTION = 'asset_transactions/REMOVE_ASSET_TRANSACTION' as const
